import { finalize, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { DirectDebit } from './../../model/direct-debit';
import { DataService } from '../../../core/service/base/data.service';

@Injectable()
export class DirectDebitService extends DataService<DirectDebit> {
  constructor(client: HttpClient, notification: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, config, notification, DirectDebit, progressBar, 'direct-debit');
  }

  export(directDebitIds: string[]): Observable<File> {
    return super.exportDataItems(directDebitIds, 'Direct_debit');
  }

  getDirectDebit(filter: any): Observable<DirectDebit[]> {
    this.progressBar.start();
    return this.client.post<DirectDebit[]>(`${this.endpoint}`, JSON.stringify(filter)).pipe(
      map(data => data.map(item => Object.assign(new DirectDebit(), item))),
      finalize(() => this.progressBar.stop())
    );
  }
}
